<template>
  <ul class="category-container">
    <li v-for="item in list" :key="item.id">
      <span @click="hanleSelect(item)" :class="{ active: item.isSelect }"
        >{{ item.name }} &nbsp;&nbsp;{{ item.aside }}</span
      >
      <Category :list="item.children" @select="hanleSelect" />
    </li>
  </ul>
</template>

<script>
export default {
  name: "Category",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    hanleSelect(item) {
      this.$emit("select", item);
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.category-container {
  margin-left: 10px;
  li {
    line-height: 40px;
    min-height: 40px;
    font-size: 14px;
    span {
      color: @gray;
      cursor: pointer;
      transition: 0.5s;
    }
    span:hover {
      color: @primary;
    }
    span.active {
      color: @primary;
      font-weight: bold;
    }
  }
}
</style>
